import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { precisaAceiteLegal } from '../../utils/legalAccess';

const ROTAS_PUBLICAS = new Set([
  '/login',
  '/cadastro',
  '/confirmar-email',
  '/termos',
  '/privacidade',
  '/aceitar-termos',
  '/esqueci-senha',
  '/tornar-se-parceiro',
  '/acesso-bloqueado',
  '/checkout/sucesso',
  '/checkout/cancelado',
]);

/** Redireciona usuários autenticados sem aceite legal vigente. */
export default function LegalEnforcer({ children }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated || !user) return;

    const path = location.pathname;
    if (ROTAS_PUBLICAS.has(path) || path.startsWith('/password-reset/') || path.startsWith('/onboarding/')) {
      return;
    }

    const gateSessao = sessionStorage.getItem('legal_gate_required') === '1';
    if ((precisaAceiteLegal(user) || gateSessao) && path !== '/aceitar-termos') {
      sessionStorage.setItem('legal_redirect_after', location.pathname + location.search);
      navigate('/aceitar-termos', { replace: true });
    } else if (!precisaAceiteLegal(user)) {
      sessionStorage.removeItem('legal_gate_required');
    }
  }, [isAuthenticated, user, location.pathname, location.search, navigate]);

  return children;
}
